import React from 'react';
import { useWizard, WizardSubStep } from '@zillow/zrs-rental-applications';
import { Flex, Heading, IconFaceUnhappy, Paragraph } from '@zillow/constellation';
import { useIdVerificationCallbacks } from '../../../contexts/IdVerificationContext';
import { ExitReason } from '../../../../../models';

interface FrozenAccountProps {
  id: string;
}

export default function ThinCreditFile({ id }: FrozenAccountProps) {
  const { currentSubStep } = useWizard();
  const { onExit } = useIdVerificationCallbacks();

  return (
    <WizardSubStep
      id={id}
      hidden={currentSubStep !== id}
      meta={{
        renderNextButton: 'Done',
        renderBackButton: () => null,
      }}
      onRequestNext={(abortController: AbortController) => {
        abortController.abort();
        onExit({ reason: ExitReason.ThinCreditFile, success: false });
      }}
      render={() => (
        <Flex display="flex" flexDirection="column" gap="sm">
          <IconFaceUnhappy size="md" fontColor="blue600" />
          <Heading level={4} as="h2">
            Limited or no credit history available
          </Heading>
          <Paragraph>We are unable to verify your identity because you have little or no credit history.</Paragraph>
        </Flex>
      )}
    />
  );
}
